export type EventCallback<T = any> = (data: T) => void;

export const EVENTS ={
  'TOOL_ADDED': 'TOOL_ADDED',
  'TOOL_REMOVED': 'TOOL_REMOVED',
  'TOOL_DRAG_START': 'TOOL_DRAG_START',
  'TOOL_DRAG_END': 'TOOL_DRAG_END',
  'TOOL_DROPPED': 'TOOL_DROPPED',
  'STATE_UPDATED': 'STATE_UPDATED',
  'UNDO': 'UNDO',
  'REDO': 'UNDO',
  "VALIDATIONERROR": "VALIDATIONERROR"
}

export class EventEmitter<TEvents extends Record<string, any>> {
  private events: { [K in keyof TEvents]?: EventCallback<TEvents[K]>[] } = {};
  private static instance: EventEmitter<any>;
  // Subscribe to an event
  subscribe<K extends keyof TEvents>(
    eventName: K,
    callback: EventCallback<TEvents[K]>
  ): () => void {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName]!.push(callback);
    return () => this.unsubscribe(eventName, callback); // Return unsubscribe function
  }

  // Unsubscribe from an event
  unsubscribe<K extends keyof TEvents>(
    eventName: K,
    callback: EventCallback<TEvents[K]>
  ): void {
    if (!this.events[eventName]) return;

    this.events[eventName] = this.events[eventName]!.filter(
      (listener) => listener !== callback
    );
  }

  // Emit an event
  emit<K extends keyof TEvents>(eventName: K, data: TEvents[K]): void {
    if (!this.events[eventName]) return;

    this.events[eventName]!.forEach((listener) => listener(data));
  }

  // Clear all listeners for an event
  clear<K extends keyof TEvents>(eventName: K): void {
    if (!this.events[eventName]) return;

    delete this.events[eventName];
  }
  static getInstance<TEvents extends Record<string, any>>() {
    if(this.instance) return this.instance;
    this.instance = new EventEmitter<TEvents>();
    return this.instance;
  }
}
